<template>
  <v-card>
    <v-card-text>

      <v-select
        :items="plansList"
        :loading="loading.plans"
        :disabled="closed"
        @change="changedPlan"
        v-model="selectedPlan"
        label="Select plan"
        return-object
        :rules="required"
      ></v-select>

      <v-select
        v-if="selectedPlan"
        :items="allCaskets"
        :disabled="closed"
        v-model="selectedCasket"
        label="Select Casket Model"
        clearable
        id="selectCasket"
      ></v-select>

      <v-flex v-if="selectedPlan && servicesList && servicesList.length > 0">
        <v-combobox
          v-if="selectedPlan && servicesList && servicesList.length > 0"
          :items="filterProducts(servicesList)"
          :loading="loading.services"
          :value="filterProducts(selectedServices)"
          :disabled="closed"
          label="Select products"
          item-value="id"
          item-text="name"
          :filter="filter"
          return-object
          multiple
          attach
          clearable
          hide-selected
          @change="updateSelectedServices($event, 'product')"
          id="selectProducts"
        >
          <template slot="item" slot-scope="props">
            Product: {{ props.item.name }} | Category: {{ props.item.category.name }}
          </template>
          <template slot="selection" slot-scope="props">
            <span class="v-chip v-chip--select-multi theme--light">
              <span class="v-chip__content">
                {{ props.item.name }}
              </span>
            </span>
          </template>
        </v-combobox>

        <v-combobox
          v-if="selectedPlan && servicesList && servicesList.length > 0"
          :items="filterAddons(servicesList, 30)"
          :loading="loading.services"
          :value="filterAddons(selectedServices, 30)"
          :disabled="closed"
          label="Select Floral Add-Ons"
          item-value="id"
          item-text="name"
          :filter="filter"
          return-object
          autofocus
          deletable-chips
          multiple
          clearable
          hide-selected
          @change="updateSelectedServices($event, 'add', 30)"
        >
          <template slot="item" slot-scope="props">
            {{ props.item.name }}
          </template>
          <template slot="selection" slot-scope="props">
            <span class="v-chip v-chip--select-multi theme--light">
              <span class="v-chip__content">
                {{ props.item.name }}
              </span>
            </span>
          </template>
        </v-combobox>

        <v-combobox
          v-if="selectedPlan && servicesList && servicesList.length > 0"
          :items="filterAddons(servicesList, 31)"
          :loading="loading.services"
          :value="filterAddons(selectedServices, 31)"
          :disabled="closed"
          label="Select Services Add-Ons"
          item-value="id"
          item-text="name"
          :filter="filter"
          return-object
          autofocus
          deletable-chips
          multiple
          clearable
          hide-selected
          @change="updateSelectedServices($event, 'add', 31)"
        >
          <template slot="item" slot-scope="props">
            {{ props.item.name }}
          </template>
          <template slot="selection" slot-scope="props">
            <span class="v-chip v-chip--select-multi theme--light">
              <span class="v-chip__content">
                {{ props.item.name }}
              </span>
            </span>
          </template>
        </v-combobox>

        <v-combobox
          v-if="selectedPlan && servicesList && servicesList.length > 0"
          :items="filterAddons(servicesList, 32)"
          :loading="loading.services"
          :value="filterAddons(selectedServices, 32)"
          :disabled="closed"
          label="Select Add-On Items"
          item-value="id"
          item-text="name"
          :filter="filter"
          return-object
          autofocus
          deletable-chips
          multiple
          clearable
          hide-selected
          @change="updateSelectedServices($event, 'add', 32)"
        >
          <template slot="item" slot-scope="props">
            {{ props.item.name }}
          </template>
          <template slot="selection" slot-scope="props">
            <span class="v-chip v-chip--select-multi theme--light">
              <span class="v-chip__content">
                {{ props.item.name }}
              </span>
            </span>
          </template>
        </v-combobox>

        <v-combobox
          v-if="selectedPlan && servicesList && servicesList.length > 0"
          :items="filterAddons(servicesList, 33)"
          :loading="loading.services"
          :value="filterAddons(selectedServices, 33)"
          :disabled="closed"
          label="Select Food and Gift Add-Ons"
          item-value="id"
          item-text="name"
          :filter="filter"
          return-object
          autofocus
          deletable-chips
          multiple
          clearable
          hide-selected
          @change="updateSelectedServices($event, 'add', 33)"
        >
          <template slot="item" slot-scope="props">
            {{ props.item.name }}
          </template>
          <template slot="selection" slot-scope="props">
            <span class="v-chip v-chip--select-multi theme--light">
              <span class="v-chip__content">
                {{ props.item.name }}
              </span>
            </span>
          </template>
        </v-combobox>

        <v-combobox
          v-if="selectedPlan && servicesList && servicesList.length > 0"
          :items="filterAddons(servicesList, 34)"
          :loading="loading.services"
          :value="filterAddons(selectedServices, 34)"
          :disabled="closed"
          label="Select Logistics Add-Ons"
          item-value="id"
          item-text="name"
          :filter="filter"
          return-object
          autofocus
          deletable-chips
          multiple
          clearable
          hide-selected
          @change="updateSelectedServices($event, 'add', 34)"
        >
          <template slot="item" slot-scope="props">
            {{ props.item.name }}
          </template>
          <template slot="selection" slot-scope="props">
            <span class="v-chip v-chip--select-multi theme--light">
              <span class="v-chip__content">
                {{ props.item.name }}
              </span>
            </span>
          </template>
        </v-combobox>

        <v-data-table
          v-if="selectedServices && selectedServices.length"
          :items="selectedServices"
          :headers="productsTableHeaders"
          hide-actions
        >
          <template slot="items" slot-scope="props">
            <td>
              <v-layout justify-space-between align-center>
                <v-combobox
                  v-if="upgrade_id === props.item.id"
                  :items="filteredProducts"
                  v-model="change_product_from_category_model"
                  @change="changeProductFromCategory(props.item)"
                  label="Select Another Product from same category"
                ></v-combobox>
                <span v-if="upgrade_id !== props.item.id">
                  {{ props.item.name }}
                </span>
                <v-btn v-if="upgrade_id !== props.item.id && !closed"
                       small
                       align-rigth
                       @click="upgradeCategory(props.item)"
                >Upgrade</v-btn>
              </v-layout>
            </td>
            <td class="quantity_bgcolor">
              <v-edit-dialog
                :return-value.sync="props.item.amount"
                large
                lazy
                persistent
              >
                <div>{{ props.item.amount }}</div>
                <template v-slot:input>
                  <div class="mt-3 title">Update Amount</div>
                </template>
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.amount"
                    label="Quantity"
                    :disabled="closed"
                    single-line
                    autofocus
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <td>${{ props.item.price }}</td>
            <td>${{ props.item.amount * props.item.price }}</td>
            <td class="justify-center layout px-0">
              <v-icon
                v-if="!closed"
                small
                @click="deleteItem(props.item)"
              >
                delete
              </v-icon>
            </td>
          </template>
          <template slot="footer">
            <v-flex>
              <v-text-field label="Remarks in $" type="number" v-model="discount" :disabled="closed"/>
            </v-flex>
            <v-flex tag="h3">
              Final price: ${{ finalPrice }}
            </v-flex>
          </template>
        </v-data-table>

        <v-flex mt-5>

          <h3>Embalming Notes</h3>

          <v-text-field v-model="tagAndRemarks" label="Tag number & other remarks" :disabled="closed"/>

          <v-flex md4>
            <v-img
              v-if="embalmers_photo_url || caseById(caseId).embalmers_photo"
              aspect-ratio="1"
              :src="embalmers_photo_url|| caseById(caseId).embalmers_photo"
            ></v-img>
            <v-progress-linear
              v-if="uploadPercentage !== 0 && uploadPercentage !== 100"
              :value="uploadPercentage"
              color="light-blue"
            ></v-progress-linear>
          </v-flex>

          <v-btn
            v-if="!closed"
            color="primary"
            class="mt-3 ml-0"
            :disabled="disabled.uploadPhotoForEmbalmersBtn"
            :loading="disabled.uploadPhotoForEmbalmersBtn"
            :prepend-icon="uploadStatus"
            @click="$refs.inputUpload.click()"
            type="file">Upload Optional Photo
          </v-btn>
          <input
            v-if="!closed"
            v-show="false"
            accept=".jpg,.png"
            ref="inputUpload"
            type="file"
            @change="onFileChange"
          >
          <v-snackbar
            v-model="snackbar"
            bottom
            color="success"
            multi-line
            :timeout="2000"
          ></v-snackbar>
        </v-flex>

        <v-flex mt-5>

          <v-checkbox v-model="isPreplan" label="Preplan" :disabled="closed"/>

          <h3 v-if="!isPreplan">Wake Dates</h3>

          <v-flex v-if="!isPreplan" xs12>
            <v-flex xs12 sm3 md2>
              <v-menu
                v-model="menuDateStart"
                id="selectStartDate"
              >
                <v-text-field
                  v-model="wakeDateStart"
                  slot="activator"
                  label="Select start date"
                  prepend-icon="event"
                  readonly
                  :disabled="closed"
                ></v-text-field>
                <v-date-picker
                  v-model="wakeDateStart"
                  reactive
                  :min="minStartDate"
                  :disabled="closed"
                />
              </v-menu>
            </v-flex>
            <v-flex xs12 sm3 md2>
              <v-text-field
                label="Select start time"
                prepend-icon="alarm"
                value="12:30:00"
                v-model="wakeTimeStart"
                type="time"
                :disabled="closed"
              />
            </v-flex>
          </v-flex>

          <v-flex v-if="!isPreplan" xs12>
            <v-flex xs12 sm3 md2>
              <v-menu
                v-model="menuDateEnd"
                id="selectEndDate"
              >
                <v-text-field
                  v-model="wakeDateEnd"
                  slot="activator"
                  label="Select end date"
                  prepend-icon="event"
                  readonly
                  :disabled="closed"
                />
                <v-date-picker
                  v-model="wakeDateEnd"
                  reactive
                  :min="minEndDate"
                  :disabled="closed"
                />
              </v-menu>
            </v-flex>
            <v-flex xs12 sm3 md2>
              <v-text-field
                label="Select end time"
                prepend-icon="alarm"
                value="12:30:00"
                v-model="wakeTimeEnd"
                type="time"
                :disabled="closed"
              />
            </v-flex>
          </v-flex>

        </v-flex>

        <v-btn color="primary"
               block
               v-if="selectedServices && selectedServices.length
               && visible.attachServicesToCaseBtn && !closed"
               :loading="loading.attachServicesToCaseBtn"
               :disabled="loading.attachServicesToCaseBtn || !validated"
               @click="attachServicesToCase"
        >
          Attach products to case
        </v-btn>

        <v-flex xs12 v-if="!validated" class="validation">
          <h4>Left to fill in:</h4>
          <ul>
            <li v-if="!selectedCasket">
              <a href="#selectCasket">Select Casket Model</a>
            </li>
            <li v-if="!selectedServices">
              <a href="#selectProducts">Select Products</a>
            </li>
            <li v-if="!wakeDateStart">
              <a href="#selectStartDate">Select Wake Start Date</a>
            </li>
            <li v-if="!wakeDateEnd">
              <a href="#selectEndDate">Select Wake End Date</a>
            </li>
          </ul>
        </v-flex>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script type="text/javascript">
  import ItemCheckList from '@/components/ItemCheckList'
  import itemTypesMixins from '@/mixins/ItemTypes'
  import casesAPI from '@/api/resources/cases'
  import { mapGetters } from 'vuex'
  import _ from 'lodash'
  import moment from 'moment'

  export default {
    components: {
      ItemCheckList
    },
    props: {
      caseId: {
        type: Number,
        required: true
      },
      editable: {
        type: Boolean,
        default: false,
        required: false
      },
      caseModel: {
        type: Object
      }
    },
    mixins: [
      itemTypesMixins
    ],
    data () {
      return {
        snackbar: false,
        upgrade_id: false,
        change_product_from_category_model: null,
        menuDateStart: null,
        menuDateEnd: null,
        wakeDateStart: this.moment().add(1, 'days').format('YYYY-MM-DD'),
        wakeDateEnd: this.moment().add(2, 'days').format('YYYY-MM-DD'),
        wakeTimeStart: moment().format('HH:mm'),
        wakeTimeEnd: moment().format('HH:mm'),
        hwakeDateStart: this.moment().add(1, 'days').format('YYYY-MM-DD'),
        hwakeDateEnd: this.moment().add(2, 'days').format('YYYY-MM-DD'),
        hwakeTimeStart: moment().format('HH:mm'),
        hwakeTimeEnd: moment().format('HH:mm'),
        embalmersPhotoIsUploaded: false,
        embalmers_photo_url: false,
        uploadPercentage: 0,
        photoForEmbalmers: null,
        tagAndRemarks: null,
        discount: null,
        productsTableHeaders: [
          { text: 'Name', value: 'name' },
          { text: 'Qty', value: 'amount', width: '5px' },
          { text: 'Unit', value: 'price' },
          { text: 'Subtotal', value: 'price' },
          { text: 'Actions', value: 'name', sortable: false }
        ],
        caseData: null,
        selectedPlan: null,
        selectedService: null,
        selectedCasket: null,
        casketPrice: 0,
        selectedServices: [],
        isPreplan: false,
        visible: {
          attachServicesToCaseBtn: false
        },
        loading: {
          plans: false,
          attachServicesToCaseBtn: false,
          services: false
        },
        attachedServicesToCase: false,
        disabled: {
          uploadPhotoForEmbalmersBtn: false
        },
        required: [
          v => !!v || 'Required'
        ]
      }
    },
    computed: {
      ...mapGetters({
        getAllCases: 'getAllCases',
        servicesList: 'allProducts',
        serviceById: 'getProductById',
        filterFromLinkedServices: 'filterFromLinkedServices',
        filterCasketFromLinkedProducts: 'filterCasketFromLinkedProducts',
        removeCasketsFromServices: 'removeCasketsFromServices',
        plansList: 'allPlans',
        planById: 'getPlanById',
        allCaskets: 'allCaskets',
        casketById: 'getCasketById',
        caseById: 'getCaseById',
        filteredProducts: 'filteredProducts'
      }),
      finalPrice () {
        return this.productsPrice + this.casketPrice - (this.discount ? this.discount : 0)
      },
      uploadStatus () {
        return this.embalmersPhotoIsUploaded ? 'done' : ''
      },
      productsPrice () {
        return this.selectedServices.reduce((total, service) => total + (service.price * service.amount), 0)
      },
      validated () {
        if (!this.isPreplan) {
          return this.wakeDateStart && this.wakeDateEnd
        } else {
          return true
        }
      },
      minStartDate () {
        return this.moment().format('YYYY-MM-DD')
      },
      minEndDate () {
        return this.wakeDateStart
      },
      closed () {
        return this.caseModel && this.caseModel.status === 'closed'
      }
    },
    watch: {
      photoForEmbalmers (photo) {
        let formData = new FormData()

        formData.append('embalmers_photo', photo)

        this.disabled.uploadPhotoForEmbalmersBtn = true
        this.disabled.uploadPhotoForEmbalmersBtn = true

        let url = this.$store.getters.config.api_host + '/api/cases/' + this.caseId + '/embalmers-photo'
        this.$store.getters.axios.post(url, formData, {
          headers: {'Content-type': 'multipart/form-data'},
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total))
          }.bind(this)
        }).then(response => {
          this.embalmers_photo_url = response.data.additional_data
          this.disabled.uploadPhotoForEmbalmersBtn = false
          this.embalmersPhotoIsUploaded = true
          this.snackbar = true

          setTimeout(() => {
            this.embalmersPhotoIsUploaded = false
          }, 5000)
        })
      },
      getAllCases () {
        this.updateCase()
      },
      plansList () {
        if (this.editable) {
          this.loading.plans = true
          this.updateCase()
        }
      },
      selectedServices: {
        handler (newObj) {
          this.visible.attachServicesToCaseBtn = true
          this.loading.attachServicesToCaseBtn = false
          this.attachedServicesToCase = false
        },
        deep: true
      },
      selectedCasket () {
        this.casketPrice = this.selectedCasket ? this.casketById(this.selectedCasket).price : 0
      },
      isPreplan (v) {
        if (v !== this.caseById(this.caseId).is_preplan) this.$store.dispatch('updateCase', {case_id: this.caseId, payload: { is_preplan: this.isPreplan }})
        if (v) {
          this.hwakeDateStart = this.wakeDateStart
          this.hwakeTimeStart = this.wakeTimeStart
          this.hwakeDateEnd = this.wakeDateEnd
          this.hwwakeTimeEnd = this.wakeTimeEnd
          this.wakeDateStart = this.wakeDateEnd = this.wakeTimeStart = this.wakeTimeEnd = null
        } else {
          this.wakeDateStart = this.hwakeDateStart
          this.wakeTimeStart = this.hwakeTimeStart
          this.wakeDateEnd = this.hwakeDateEnd
          this.wakeTimeEnd = this.hwwakeTimeEnd
        }
      },
      caseModel (c) {
        this.discount = c.discount || 0
      }
    },
    methods: {
      updateCase () {
        if (this.caseById(this.caseId)) {
          let result = this.caseById(this.caseId)
          this.caseData = result
          this.selectedPlan = result.plans_id !== null ? this.planById(result.plans_id) : null
          this.tagAndRemarks = result.embalmers_remarks

          if (!result.is_preplan) {
            this.wakeDateStart = this.caseData.wake_start
              ? moment(this.caseData.wake_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
              : this.moment().add(1, 'days').format('YYYY-MM-DD')
            this.wakeDateEnd = this.caseData.wake_end
              ? moment(this.caseData.wake_end, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
              : null
          }

          this.wakeTimeStart = this.caseData.wake_start ? moment(this.caseData.wake_start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm') : '11:30'
          this.wakeTimeEnd = this.caseData.wake_end ? moment(this.caseData.wake_end, 'YYYY-MM-DD HH:mm:ss').format('HH:mm') : '12:30'

          let casket = this.filterCasketFromLinkedProducts(this.caseData.services)
          let planCasket = this.selectedPlan ? this.filterCasketFromLinkedProducts(this.selectedPlan.services) : false
          this.selectedCasket = casket || planCasket

          this.isPreplan = result.is_preplan

          this.selectedServices = this.filterFromLinkedServices(this.caseData.services)
          this.loading.plans = false
        } else {
          this.loading.plans = false
        }
      },
      deleteItem (item) {
        const index = this.selectedServices.indexOf(item)
        this.selectedServices.splice(index, 1)
      },
      changeProductFromCategory (oldItem) {
        if (oldItem.id !== this.change_product_from_category_model) {
          this.selectedServices = _.unionBy([this.serviceById(this.change_product_from_category_model.id)], this.selectedServices, 'id')
          this.deleteItem(oldItem)
        }
        this.change_product_from_category_model = null
        this.upgrade_id = false
      },
      upgradeCategory (item) {
        this.upgrade_id = item.id
        this.$store.dispatch('filterProducts', item.categories_id === undefined ? null : {id: item.categories_id})
      },
      changedPlan (plan) {
        if (undefined === plan) {
          return
        }

        if (this.filterCasketFromLinkedProducts(this.selectedPlan.services)) {
          this.selectedCasket = this.filterCasketFromLinkedProducts(this.selectedPlan.services)
        }

        if (this.selectedCasket) {
          this.casketPrice = this.casketById(this.selectedCasket).price
        }

        this.visible.attachServicesToCaseBtn = true
        this.selectedServices = this.removeCasketsFromServices(this.filterFromLinkedServices(this.planById(plan.id).services))
        // this.selectedServices = _.unionBy(this.removeCasketsFromServices(this.filterFromLinkedServices(this.planById(plan.id).services)), this.selectedServices, 'id')
      },
      onFileChange (event) {
        this.photoForEmbalmers = event.target.files[0]
      },
      deleteElementSuccess () {
        this.$store.dispatch('getAllProducts')
      },
      deleteElementWrapper (itemId) {
        this.deleteElement(itemId)
        this.$store.dispatch('getAllProducts')
      },
      filter (item, query) {
        if (!query || query === '' || typeof query === 'undefined') {
          return true
        }

        query = query.toLowerCase()

        return item.name.toLowerCase().includes(query) || item.user && item.user.name.toLowerCase().includes(query) || item.category && item.category.name.toLowerCase().includes(query)
      },
      goToCase () {
        this.$router.push({ name: 'CasesDetail', params: { id: this.caseId } })
      },
      attachServicesToCase () {
        this.loading.attachServicesToCaseBtn = true

        let selectedServices = this.selectedServices
        if (this.selectedCasket) selectedServices.push(this.casketById(this.selectedCasket))

        let wakeDateTimeStart = this.wakeDateStart ? (moment(this.wakeDateStart, 'YYYY-MM-DD').format('YYYY-MM-DD')) + ' ' +
          (this.wakeTimeStart ? moment(this.wakeTimeStart, 'HH:mm:ss').format('HH:mm:ss') : moment().format('HH:mm:ss'))
          : ''

        let wakeDateTimeEnd = this.wakeDateEnd ? (moment(this.wakeDateEnd, 'YYYY-MM-DD').format('YYYY-MM-DD')) + ' ' +
          (this.wakeTimeEnd ? moment(this.wakeTimeEnd, 'HH:mm:ss').format('HH:mm:ss') : moment().format('HH:mm:ss'))
          : ''

        let promise = casesAPI.attachServicesPlanCasketToCase(this.caseId, selectedServices, this.discount, this.selectedPlan, this.tagAndRemarks, wakeDateTimeStart, wakeDateTimeEnd)
        this.selectedServices = this.removeCasketsFromServices(this.selectedServices)
        promise.then(promise).then(() => {
          this.loading.attachServicesToCaseBtn = true

          this.attachedServicesToCase = true
          this.loading.attachServicesToCaseBtn = false
          this.visible.attachServicesToCaseBtn = false

          setTimeout(() => {
            this.$store.dispatch('loadAllCases')
            this.$store.dispatch('getCaseInvoices', this.caseId)
          }, 2000)

          if (this.$router.history.current.path === '/onboard-client') {
            this.goToCase()
          } else if (this.caseId) {
            setTimeout(() => {
              this.$store.dispatch('getCaseLog', this.caseId)
            }, 2000)
          }
        }, () => {})
      },
      filterProducts (items) {
        // return items.filter(i => i.categories_id !== 10)
        return items.filter(i => i.category.name !== 'Add on Items' && !i.category.name.includes('Add-On'))
      },
      filterAddons (items, categoryId) {
        return items.filter(i => i.categories_id === categoryId)
      },
      filterAllAddons (items, categoryId) {
        // return items.filter(i => i.categories_id !== 10)
        return items.filter(i => i.category.name.includes('Add-On') && i.categories_id !== categoryId)
      },
      updateSelectedServices (event, op, category = 30) {
        const currentProducts = op === 'product' ? event : this.filterProducts(this.selectedServices)
        const allAddons = this.filterAllAddons(this.selectedServices, category)
        const currentAddons = op === 'add' ? event : null
        const newServices = currentProducts.concat(allAddons).concat(currentAddons)
        this.selectedServices = newServices
      }
    },
    beforeCreate () {
      this.$store.dispatch('getAllPlans')
      this.$store.dispatch('getAllProducts')
    }
  }
</script>

<style>
  .quantity_bgcolor {
    background-color: #8c9eff;
  }
  .validation a {
    text-decoration: none;
    border-bottom: 1px dotted;
  }
  .validation a:hover {
    text-decoration: none;
    border-bottom: none;
  }
</style>



// WEBPACK FOOTER //
// SelectPlanAndVendors.vue?0703bd2a